import { JapanPrefecture } from '@/gql/graphql'

export const snsShareRecommendedJobOptions = [
  {
    name: '宇宙飛行士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/astronaut',
    text: `思考力チャレンジの結果、あなたに向いている職業は「宇宙飛行士」でした！✨
高い空間認識力を活かして、未知の宇宙空間を自由自在に飛び回れるかも🚀`,
    hashTags: ['思考力チャレンジ', '職業分析', '宇宙飛行士', 'タブレット学習'],
  },
  {
    name: 'ふりつけ師',
    url: 'https://www.sonyged.com/logiq/job-aptitude/choreographer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ふりつけ師」でした！✨
空間認識力を活かして動きをデザインすることで、観る人の心を動かすような振り付けができるかも💃`,
    hashTags: ['思考力チャレンジ', '職業分析', 'ふりつけ師', 'タブレット学習'],
  },
  {
    name: '写真家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/photographer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「写真家」でした！✨
空間認識力と探索力を活かして、大事なシャッターチャンスをとらえて素敵な写真が撮れるかも📸`,
    hashTags: ['思考力チャレンジ', '職業分析', '写真家', 'タブレット学習'],
  },
  {
    name: 'アニメータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/animator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「アニメータ」でした！✨
探索力と空間認識力を活かして、人を笑顔にできるようなアニメーションがつくれるかも🎨`,
    hashTags: ['思考力チャレンジ', '職業分析', 'アニメータ', 'タブレット学習'],
  },
  {
    name: '化石研究員',
    url: 'https://www.sonyged.com/logiq/job-aptitude/fossil_researcher',
    text: `思考力チャレンジの結果、あなたに向いている職業は「化石研究員」でした！✨
探索力と空間認識力を駆使して、隠れた化石を探し出すことができちゃうかも🔍🦴`,
    hashTags: ['思考力チャレンジ', '職業分析', '化石研究員', 'タブレット学習'],
  },
  {
    name: '探てい',
    url: 'https://www.sonyged.com/logiq/job-aptitude/detective',
    text: `思考力チャレンジの結果、あなたに向いている職業は「探偵」でした！✨
探索することが特に得意なので、小さなヒントから真実を暴くことができちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '探偵', 'タブレット学習'],
  },
  {
    name: '探検家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/explorer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「探検家」でした！✨
探索力が抜群なので、未知の世界を切り拓いていけるかも🧭`,
    hashTags: ['思考力チャレンジ', '職業分析', '探検家', 'タブレット学習'],
  },
  {
    name: 'パイロット',
    url: 'https://www.sonyged.com/logiq/job-aptitude/pilot',
    text: `思考力チャレンジの結果、あなたに向いている職業は「パイロット」でした！✨
空間認識力が高く、広い空を自在に飛び回る才能があるかも🛫`,
    hashTags: ['思考力チャレンジ', '職業分析', 'パイロット', 'タブレット学習'],
  },
  {
    name: 'インテリアコーディネータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/interior_coordinator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「インテリアコーディネータ」でした！✨
空間認識力を活かして、おしゃれで使いやすい空間をデザインできるかも🏡`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'インテリアコーディネータ',
      'タブレット学習',
    ],
  },
  {
    name: 'ステージ演出家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/stage_director',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ステージ演出家」でした！✨
空間認識力と探索力を活かして、お芝居やダンスの舞台を鮮やかに演出できる才能があるかも🎭`,
    hashTags: ['思考力チャレンジ', '職業分析', '舞台演出家', 'タブレット学習'],
  },
  {
    name: '環境エンジニア',
    url: 'https://www.sonyged.com/logiq/job-aptitude/environmental_engineer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「環境エンジニア」でした！✨
探索力と空間認識力を活かして、自然や環境の課題を解決するエンジニアになれるかも🌿`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      '環境エンジニア',
      'タブレット学習',
    ],
  },
  {
    name: '考古学者',
    url: '	https://www.sonyged.com/logiq/job-aptitude/archaeologist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「考古学者」でした！✨
探索力を活かして、誰も知らない歴史を掘り起こせちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '考古学者', 'タブレット学習'],
  },
  {
    name: '発明家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/inventor',
    text: `思考力チャレンジの結果、あなたに向いている職業は「発明家」でした！✨
探索力を活かして、毎日の生活がもっと楽しくなる便利なものを発明できちゃうかも🔬`,
    hashTags: ['思考力チャレンジ', '職業分析', '発明家', 'タブレット学習'],
  },
  {
    name: '建築家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/architect',
    text: `思考力チャレンジの結果、あなたに向いている職業は「建築家」でした！✨
空間認識力を活かして、かっこよく快適な建物を設計できるかも🏢`,
    hashTags: ['思考力チャレンジ', '職業分析', '建築家', 'タブレット学習'],
  },
  {
    name: 'ゲームクリエータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/game_creator',
    text: `思考力チャレンジの結果、あなたに向いている職業は
「ゲームクリエイター」でした！✨
空間認識力と情報読解力を活かして、みんなが楽しめる新しいゲームをつくり出せるかも🎯`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'ゲームクリエイター',
      'タブレット学習',
    ],
  },
  {
    name: '絵本作家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/picture_book_author',
    text: `思考力チャレンジの結果、あなたに向いている職業は「絵本作家」でした！✨
空間認識力、情報読解力、探索力をバランス良く活かして、想像力豊かなワクワクする物語をつくれるかも📚`,
    hashTags: ['思考力チャレンジ', '職業分析', '絵本作家', 'タブレット学習'],
  },
  {
    name: '脳科学者',
    url: 'https://www.sonyged.com/logiq/job-aptitude/neuroscientist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「脳科学者」でした！✨
情報読解力と探索力を活かして、脳の仕組みを解明できちゃうかも🧠🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '脳科学者', 'タブレット学習'],
  },
  {
    name: 'データサイエンティスト',
    url: 'https://www.sonyged.com/logiq/job-aptitude/data_scientist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「データサイエンティスト」でした！✨
探索力と情報読解力を活かして、データに隠れた大事なヒントを見つけ出せるかも🔍`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'データサイエンティスト',
      'タブレット学習',
    ],
  },
  {
    name: '外科医',
    url: 'https://www.sonyged.com/logiq/job-aptitude/surgeon',
    text: `思考力チャレンジの結果、あなたに向いている職業は「外科医」でした！✨
情報読解力と空間認識力を活かして、病気やけがを治す人になれるかも💉`,
    hashTags: ['思考力チャレンジ', '職業分析', '外科医', 'タブレット学習'],
  },
  {
    name: 'フードコーディネータ',
    url: 'https://www.sonyged.com/logiq/job-aptitude/food_coordinator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「フードコーディネータ」でした！✨
情報読解力と空間認識力を活かして、美味しい料理を素敵に盛り付けられるかも🍽️🌟`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'フードコーディネータ',
      'タブレット学習',
    ],
  },
  {
    name: '起業家',
    url: 'https://www.sonyged.com/logiq/job-aptitude/entrepreneur',
    text: `思考力チャレンジの結果、あなたに向いている職業は「起業家」でした！✨
情報読解力と探索力を活かして、新しいお店や会社をつくれちゃうかも🚀`,
    hashTags: ['思考力チャレンジ', '職業分析', '起業家', 'タブレット学習'],
  },
  {
    name: 'ジャーナリスト',
    url: 'https://www.sonyged.com/logiq/job-aptitude/journalist',
    text: `思考力チャレンジの結果、あなたに向いている職業は「ジャーナリスト」でした！✨
情報読解力と探索力を活かして、ニュースや出来事をわかりやすく伝えることができるかも📰`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'ジャーナリスト',
      'タブレット学習',
    ],
  },
  {
    name: '航海士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/navigator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「航海士」でした！✨
情報読解力と空間認識力を活かして、地図や天気を正確に読み取って航路を導き出るかも🧭`,
    hashTags: ['思考力チャレンジ', '職業分析', '航海士', 'タブレット学習'],
  },
  {
    name: '科学そうさ官',
    url: 'https://www.sonyged.com/logiq/job-aptitude/science_investigator',
    text: `思考力チャレンジの結果、あなたに向いている職業は「科学捜査官」でした！✨
情報読解力を活かして、現場の証拠から真実を解明できちゃうかも🔍`,
    hashTags: ['思考力チャレンジ', '職業分析', '科学捜査官', 'タブレット学習'],
  },
  {
    name: 'プログラマー',
    url: 'https://www.sonyged.com/logiq/job-aptitude/programmer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「プログラマー」でした！✨
情報読解力と探索力を活かしてコンピュータに指示を出し、ゲームやアプリを開発できるかも💻🔍`,
    hashTags: [
      '思考力チャレンジ',
      '職業分析',
      'プログラマー',
      'タブレット学習',
    ],
  },
  {
    name: '航空管制官',
    url: 'https://www.sonyged.com/logiq/job-aptitude/air_traffic_controller',
    text: `思考力チャレンジの結果、あなたに向いている職業は「航空管制官」でした！✨
情報読解力と空間認識力を活かして、安全な空の交通を支えられるかも✈️🚦`,
    hashTags: ['思考力チャレンジ', '職業分析', '航空管制官', 'タブレット学習'],
  },
  {
    name: '弁護士',
    url: 'https://www.sonyged.com/logiq/job-aptitude/lawyer',
    text: `思考力チャレンジの結果、あなたに向いている職業は「弁護士」でした！✨
情報読解力を活かして、法律や物事を正しく読み解いて問題を解決できるかも⚖️`,
    hashTags: ['思考力チャレンジ', '職業分析', '弁護士', 'タブレット学習'],
  },
  {
    name: '新聞記者',
    url: 'https://www.sonyged.com/logiq/job-aptitude/newspaper_reporter',
    text: `思考力チャレンジの結果、あなたに向いている職業は「新聞記者」でした！✨
高い情報読解力を活かして、いろいろな出来事を新聞を通して正確にわかりやすく伝えられるかも📰`,
    hashTags: ['思考力チャレンジ', '職業分析', '新聞記者', 'タブレット学習'],
  },
]

export const prefectureOptionsMap = {
  [JapanPrefecture.Hokkaido]: '北海道',
  [JapanPrefecture.Aomori]: '青森県',
  [JapanPrefecture.Iwate]: '岩手県',
  [JapanPrefecture.Miyagi]: '宮城県',
  [JapanPrefecture.Akita]: '秋田県',
  [JapanPrefecture.Yamagata]: '山形県',
  [JapanPrefecture.Fukushima]: '福島県',
  [JapanPrefecture.Ibaraki]: '茨城県',
  [JapanPrefecture.Tochigi]: '栃木県',
  [JapanPrefecture.Gunma]: '群馬県',
  [JapanPrefecture.Saitama]: '埼玉県',
  [JapanPrefecture.Chiba]: '千葉県',
  [JapanPrefecture.Tokyo]: '東京都',
  [JapanPrefecture.Kanagawa]: '神奈川県',
  [JapanPrefecture.Niigata]: '新潟県',
  [JapanPrefecture.Toyama]: '富山県',
  [JapanPrefecture.Ishikawa]: '石川県',
  [JapanPrefecture.Fukui]: '福井県',
  [JapanPrefecture.Yamanashi]: '山梨県',
  [JapanPrefecture.Nagano]: '長野県',
  [JapanPrefecture.Gifu]: '岐阜県',
  [JapanPrefecture.Shizuoka]: '静岡県',
  [JapanPrefecture.Aichi]: '愛知県',
  [JapanPrefecture.Mie]: '三重県',
  [JapanPrefecture.Shiga]: '滋賀県',
  [JapanPrefecture.Kyoto]: '京都府',
  [JapanPrefecture.Osaka]: '大阪府',
  [JapanPrefecture.Hyogo]: '兵庫県',
  [JapanPrefecture.Nara]: '奈良県',
  [JapanPrefecture.Wakayama]: '和歌山県',
  [JapanPrefecture.Tottori]: '鳥取県',
  [JapanPrefecture.Shimane]: '島根県',
  [JapanPrefecture.Okayama]: '岡山県',
  [JapanPrefecture.Hiroshima]: '広島県',
  [JapanPrefecture.Yamaguchi]: '山口県',
  [JapanPrefecture.Tokushima]: '徳島県',
  [JapanPrefecture.Kagawa]: '香川県',
  [JapanPrefecture.Ehime]: '愛媛県',
  [JapanPrefecture.Kochi]: '高知県',
  [JapanPrefecture.Fukuoka]: '福岡県',
  [JapanPrefecture.Saga]: '佐賀県',
  [JapanPrefecture.Nagasaki]: '長崎県',
  [JapanPrefecture.Kumamoto]: '熊本県',
  [JapanPrefecture.Oita]: '大分県',
  [JapanPrefecture.Miyazaki]: '宮崎県',
  [JapanPrefecture.Kagoshima]: '鹿児島県',
  [JapanPrefecture.Okinawa]: '沖縄県',
} as const

export const contestAttemptAgeGroupOptions = {
  ['P1']: '年少以下',
  ['P2']: '年中',
  ['P3']: '年長',
  ['E1']: '小学1年生',
  ['E2']: '小学2年生',
  ['E3']: '小学3年生',
  ['E4']: '小学4年生',
  ['E5']: '小学5年生',
  ['E6']: '小学6年生',
  ['J1']: '中学1年生',
  ['J2']: '中学2年生',
  ['J3']: '中学3年生',
  ['PRESCHOOL']: '未就学',
  ['ELEMENTARY_SCHOOL']: '小学生',
  ['JUNIOR_HIGH_SCHOOL']: '中学生',
  ['HIGH_SCHOOL']: '高校生',
  ['GENERAL']: '一般',
  ['AGE_LTE_10']: '10歳未満(0-9)',
  ['AGE_10S']: '10代',
  ['AGE_20S']: '20代',
  ['AGE_30S']: '30代',
  ['AGE_40S']: '40代',
  ['AGE_50S']: '50代',
  ['AGE_GTE_60']: '60代以上',
} as const
